var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-trainings-standard" },
    [
      _vm.detail.name
        ? _c("div", { staticClass: "training-standard__header" }, [
            _c(
              "div",
              {
                staticClass:
                  "training-standard__header__title yxt-weight-5 lh22",
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("pc_gwnl_training_standards")) +
                    "\n    "
                ),
              ]
            ),
            _c("div", { staticClass: "training-standard__header__subtitle" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_gwnl_training_standard_title")) +
                  "\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "training-standard__content pt40 pb20 pl24 pr24" },
        [
          !_vm.detail.name
            ? _c("div", { staticClass: "training-standard__empty" }, [
                _c("div", { staticClass: "mb24" }, [
                  _c("div", { staticClass: "empty-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("pc_gwnl_training_standard_title")) +
                        "\n        "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "empty-subtitle mt12 text-center" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("pc_gwnl_training_standard_subtitle")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "flex" },
                  _vm._l(_vm.emptyArr, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.title,
                        staticClass: "pl24 pt32 empty-card",
                        class: item.bgimg,
                      },
                      [
                        _c("div", { staticClass: "empty-card-title mb8" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.title) +
                              "\n          "
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "empty-card-subtitle mb24 mr22 nowrap-2",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.subTitle) +
                                "\n          "
                            ),
                          ]
                        ),
                        _c("yxt-image", {
                          attrs: {
                            src:
                              _vm.$staticBaseUrl +
                              "ufd/c4d5f9/gwnl/pc/img/" +
                              item.imgSrc,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "mt32" },
                  [
                    _vm.publishStatus === 3
                      ? _c(
                          "yxt-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              placement: "top",
                              content: _vm.$t(
                                "pc_gwnl_web_trainingEnded" /* 项目已结束 */
                              ),
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "yxt-button",
                                  { attrs: { type: "primary", disabled: "" } },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "pc_gwnl_jq_selectSkillModel" /* 选择能力模型 */
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _c(
                          "yxt-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.selectModel },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("pc_gwnl_jq_selectSkillModel")) +
                                "\n        "
                            ),
                          ]
                        ),
                  ],
                  1
                ),
              ])
            : _vm.detail.name
            ? _c(
                "div",
                { staticClass: "training-standard__models" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-align-center mb20 ht32",
                      class: {
                        mb28:
                          _vm.isShowSkillLevel &&
                          _vm.toggleRadio === _vm.$t("pc_gwnl_web_radarShow"),
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "standard-yxt-form-item ellipsis mr12" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.detail.name) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm.publishStatus > 2
                        ? [
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t(
                                    "pc_gwnl_web_trainingEnded" /* 项目已结束 */
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c("span", { staticClass: "re-change" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("pc_gwnl_training_re_change")
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        : _c(
                            "yxt-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.selectVisibleChange },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("pc_gwnl_training_re_change")) +
                                  "\n        "
                              ),
                            ]
                          ),
                    ],
                    2
                  ),
                  _c("preview-skills", {
                    staticClass: "gwnl-preview-d_jump",
                    attrs: {
                      list: _vm.detail.skillCatalogModels,
                      "show-header": false,
                      "show-behavior": true,
                      "enable-skill-level": _vm.detail.enableSkillLevel === 1,
                      "enable-excellent-level": _vm.detail.enableExcellentLevel,
                      "enable-weight-switch": _vm.detail.enableWeightSwitch,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("yxtbiz-model-selector", {
        ref: "modelSelector",
        attrs: { source: -1, type: 2, "default-value": _vm.modelId },
        on: { success: _vm.selectModelSuccess, preview: _vm.preview },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }